import React, { FC } from 'react';
import styled from 'styled-components';
import { CustomIcon } from 'components/custom-icon/CustomIcon';
import { translate, translationKeys } from 'logic/translations/translations.service';
import {
  CHECK_ICON_PRIMARY,
  GROUP_ICON_PRIMARY,
  SCHOOL_ICON_PRIMARY,
  SEARCH_CARD_ICON_PRIMARY,
  SPEECH_ICON_PRIMARY,
} from 'assets/icons/icons';
import { Text } from 'components/text/Text';
import { highlightedBodyFontSize } from 'src/pages-all/home/home.page.const';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';

const Item = styled.div`
  display: flex;
  max-width: 500px;
  flex: 1;
  margin: 20px 0;
  align-items: center;
`;

const TextBox = styled.div`
  margin-left: 20px;
  text-align: left;
`;

const bulletpointList = [
  {
    icon: SCHOOL_ICON_PRIMARY,
    textKey: translationKeys.homepage.howWeChooseElitetutors.content.bulletpoints_SCHOOL_ICON,
  },
  {
    icon: GROUP_ICON_PRIMARY,
    textKey: translationKeys.homepage.howWeChooseElitetutors.content.bulletpoints_GROUP_ICON,
  },
  {
    icon: CHECK_ICON_PRIMARY,
    textKey: translationKeys.homepage.howWeChooseElitetutors.content.bulletpoints_CHECK_ICON,
  },
  {
    icon: SPEECH_ICON_PRIMARY,
    textKey: translationKeys.homepage.howWeChooseElitetutors.content.bulletpoints_SPEECH_ICON,
  },
  {
    icon: SEARCH_CARD_ICON_PRIMARY,
    textKey: translationKeys.homepage.howWeChooseElitetutors.content.bulletpoints_SEARCH_CARD,
  },
];

export const BulletPoints: FC = () => {
  const { maxMobileLarge } = useBreakpoints();
  return (
    <>
      {
        bulletpointList.map((bulletpoint, i) => (
          <Item key={i}>
            <CustomIcon
              src={bulletpoint.icon}
              height={50}
              width={50}
            />
            <TextBox>
              <Text color={'blueGray'} size={highlightedBodyFontSize(maxMobileLarge)} fontWeight={600}>{translate(bulletpoint.textKey.regular1)}</Text>
              <Text color={'blueGray'} size={highlightedBodyFontSize(maxMobileLarge)} fontWeight={700}>{translate(bulletpoint.textKey.bold)}</Text>
              <Text color={'blueGray'} size={highlightedBodyFontSize(maxMobileLarge)} fontWeight={600}>{translate(bulletpoint.textKey.regular2)}</Text>
            </TextBox>
          </Item>
        ))
      }
    </>
  );
};
